import type { NextApiHandler } from 'next'
import { getAccessToken } from '../getSessionInfo'
import { Auth0B2CException, handleAuth0ErrorStatus, logAuth0Error } from '../error'
import { serializeSilentLoginCookie } from '../../utils'

type ApiAuthHeaderConfig = {
  required?: boolean
}

export const withApiAuthorizationHeader =
  (apiRoute: NextApiHandler, { required = true }: ApiAuthHeaderConfig = {}): NextApiHandler =>
  async (req, res) => {
    try {
      const { accessToken } = await getAccessToken(req, res)

      req.headers.authorization = `Bearer ${accessToken}`

      // TODO: could validate the token here similar to the middleware in bff
    } catch (error) {
      // if access token fails when auth header is required
      if (required && error instanceof Error) {
        // will trigger a silent login when user navigates away or refreshes
        const resetSilentLoginCookie = serializeSilentLoginCookie(false)
        res.setHeader('Set-Cookie', resetSilentLoginCookie)

        const authError = new Auth0B2CException(error, 'REQUEST_UNAUTHORIZED')
        const message = 'Failed to get access token header'
        logAuth0Error(message, authError, req, res)
        handleAuth0ErrorStatus(authError, req, res)
      }
    }

    return apiRoute(req, res)
  }
